import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { EnvService } from '../service/env.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';

declare const SwaggerUIBundle: any;
declare const SwaggerUIStandalonePreset: any;

@Component({
  selector: 'app-swagger-ui',
  templateUrl: './swagger-ui.component.html',
  styleUrls: ['./swagger-ui.component.scss']
})
export class SwaggerUiComponent implements OnInit {

  accountCategory: string;
  accountType: string;

  swaggerResources: Array<any> = [];
  swaggerResourceData: any;
  showSwagger: boolean = false;
  selectedSwaggerResource: any;
  nccFleetFoundationApis = "NCC_NNA_Fleet_Foundation_APIs_v2.3.pdf";
  mimeType = "pdf";

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService,
    private env: EnvService, private http: HttpClient) { }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    this.getSwaggerResources();
  }

  getSwaggerResources() {
    this.swaggerResources = [];
    this.utilService.showSpinner();
    this.apiService.getSwaggerResources().then((data) => {
      this.utilService.hideSpinner();
      console.log("swagger resources::", data);
      if(!isNullOrUndefined(data) && data.length > 0) {
        this.swaggerResources = data;
        this.openSwagger(this.swaggerResources[0]);
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getSwaggerResources();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  openSwagger(resource: any) {
    this.selectedSwaggerResource = resource;
    this.swaggerResourceData = null;
    this.utilService.showSpinner();
    this.apiService.getSwaggerResourceData(resource.url).then((data) => {
      this.utilService.hideSpinner();
      console.log("swagger resources data::", data);
      this.loadSwagger(data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.openSwagger(resource.url);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  loadSwagger(specData): void {
    this.showSwagger = true;
    specData['host'] = this.env.SWAGGER_HOST;
    specData['schemes'] = ['https'];
    const ui = SwaggerUIBundle({
      dom_id: '#swagger-ui',
      layout: 'BaseLayout',
      presets: [
        SwaggerUIBundle.presets.apis,
        SwaggerUIStandalonePreset
      ],
      spec: specData,
      docExpansion: 'none',
      operationsSorter: 'alpha'
    });
  }

  onCloseSwagger() {
    this.showSwagger = false;
  }

  downloadPdf() {
    console.log("attachment mime type::", this.mimeType);
    this.utilService.showSpinner();
    var attachmentUrl = this.env.API_DOC_BASE_URL + Constants.ASSETS + Constants.DOCS + this.nccFleetFoundationApis;

    this.apiService.downloadPdf(attachmentUrl).then((data) => {
      this.prepareToDownload(data, this.mimeType, this.nccFleetFoundationApis);
      this.utilService.hideSpinner();
    }).catch((error) => {
      console.log("err : ", error);
      if (error && error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.downloadPdf();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareToDownload(data, mimeType, filename: string) {
    var blob = new Blob([data], {type: mimeType});

    var downloadURL = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = downloadURL;
    link.download = filename;
    link.click();
  }

} 